import styles from './Experience.module.scss';
import { useTranslation } from "react-i18next";

export default function Experience() {
    const { t } = useTranslation();

    const experiences = [
        {
            key: 'wst',
            hasAchievements: true,
            hasDescription: true,
            hasStack: true
        },
        {
            key: 'freelance',
            hasAchievements: true,
            hasDescription: false,
            hasStack: true
        },
        {
            key: 'angeloni',
            hasAchievements: false,
            hasDescription: true,
            hasStack: false
        },
        {
            key: 'torrecid',
            hasAchievements: true,
            hasDescription: true,
            hasStack: true
        }
    ];

    return (
        <div id="Experience" className={`${styles.experience} container`}>
            <h1 className={styles.experienceTitle}>{t("Experience.title")}</h1>

            <div className={styles.timeline}>
                {experiences.map((exp) => (
                    <article key={exp.key} className={styles.experienceItem}>
                        <div className={styles.experienceHeader}>
                            <h2 className={styles.position}>{t(`Experience.${exp.key}.position`)}</h2>
                            <h3 className={styles.company}>{t(`Experience.${exp.key}.company`)}</h3>
                            <div className={styles.meta}>
                                <span className={styles.period}>{t(`Experience.${exp.key}.period`)}</span>
                                <span className={styles.separator}>•</span>
                                <span className={styles.location}>{t(`Experience.${exp.key}.location`)}</span>
                            </div>
                        </div>

                        {exp.hasDescription && (
                            <p className={styles.description}>
                                {t(`Experience.${exp.key}.description`)}
                            </p>
                        )}

                        {exp.hasAchievements && (
                            <ul className={styles.achievements}>
                                {(t(`Experience.${exp.key}.achievements`, { returnObjects: true }) as string[]).map((achievement: string, index: number) => (
                                    <li key={index}>{achievement}</li>
                                ))}
                            </ul>
                        )}

                        {exp.hasStack && (
                            <p className={styles.stack}>
                                <strong>Stack:</strong> {t(`Experience.${exp.key}.stack`)}
                            </p>
                        )}
                    </article>
                ))}
            </div>
        </div>
    );
}
